import style from './Calendar.module.css';
import { useState, useEffect, useRef, useContext } from 'react';
import { AppContext } from '../../../AppContext';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import icons from '../../../icons';
import Checkbox from '../../Checkbox/Checkbox';
import { doc, updateDoc } from 'firebase/firestore';
import { db, storage } from '../../../firebase';
import constants from '../../../constants';
// import QUERIES from '../../../workers/functions';

import Lottie, { LottiePlayer } from 'lottie-react';
import check_animation from '../../../lottieAnimations/checkmark.json';
import { getDownloadURL, ref } from 'firebase/storage';
import Banner from '../../Banner/Banner';


const addDays = (date, days) => {
    let newDate = new Date(date.valueOf());
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}

const getItalianMonth = month => {
    switch(month) {
        case 0:
            return "Gennaio";
        case 1:
            return "Febbraio";
        case 2:
            return "Marzo";
        case 3:
            return "Aprile";
        case 4:
            return "Maggio";
        case 5:
            return "Giugno";
        case 6:
            return "Luglio";
        case 7:
            return "Agosto";
        case 8:
            return "Settembre";
        case 9:
            return "Ottobre";
        case 10:
            return "Novembre";
        case 11:
            return "Dicembre";
    }
};

const getAttachmentIcon = attachmentType => {
    switch (true) {
        case attachmentType.includes("txt"):
            return icons.word_icon;
        case attachmentType.includes("doc"):
            return icons.word_icon;
        case attachmentType.includes("png"):
            return icons.photo_icon;
        case attachmentType.includes("jpg"):
            return icons.photo_icon;
        case attachmentType.includes("webp"):
            return icons.photo_icon;
        case attachmentType.includes("xlsx"):
            return icons.excel_icon;
        default:
            return icons.question_mark_orange_icon;
    }
};

const literalGrades = [
    "0", "0+", "0½", "1-",
    "1", "1+", "1½", "2-",
    "2", "2+", "2½", "3-",
    "3", "3+", "3½", "4-",
    "4", "4+", "4½", "5-",
    "5", "5+", "5½", "6-",
    "6", "6+", "6½", "7-",
    "7", "7+", "7½", "8-",
    "8", "8+", "8½", "9-",
    "9", "9+", "9½", "10-",
    "10", "10+"
];

const numericGrades = [
    0, 0.3, 0.5, 0.8,
    1, 1.3, 1.5, 1.8,
    2, 2.3, 2.5, 2.8,
    3, 3.3, 3.5, 3.8,
    4, 4.3, 4.5, 4.8,
    5, 5.3, 5.5, 5.8,
    6, 6.3, 6.5, 6.8,
    7, 7.3, 7.5, 7.8,
    8, 8.3, 8.5, 8.8,
    9, 9.3, 9.5, 9.8,
    10, 10

];

const getLiteralGrade = numericGrade => {
    if (numericGrade === null) return null;
    return literalGrades[numericGrades.indexOf(parseFloat(numericGrade))];
}

const Calendar = props => {
    const { user, tests, interrogations, homeworks, others, subjects, timetable, setTests, setInterrogations, setHomeworks, setOthers, setPage } = useContext(AppContext);
    
    const [calendar, setCalendar] = useState(null);
    const [calendarActiveSlide, setCalendarActiveSlide] = useState(0);
    const [date, setDate] = useState(new Date());

    const [swiperLoaded, setSwiperLoaded] = useState(null);

    const swiper = useRef();

    const getTypeIcon = (eventType, disabled=false) => {
        switch (eventType) {
            case "test":
                return disabled ? icons.test_disabled_icon : icons.test_icon;
            case "interrogation":
                return disabled ? icons.interrogation_disabled_icon : icons.interrogation_icon;
            case "homework":
                return disabled ? icons.homework_disabled_icon : icons.home_orange_icon;
            default:
                return disabled ? icons.question_mark_orange_disabled_icon : icons.question_mark_orange_icon;
        }
    };

    const getSubjectIcon = subjectName => {
        let returnIcon = "question_mark_orange_icon";

        if (subjects)
            Object.values(subjects).forEach(subject => {
                if (subject.subject?.toLowerCase() === subjectName?.toLowerCase()) returnIcon = subject.icon;
            });

        return returnIcon;
    };

    const getItalianType = eventType => {
        switch (eventType) {
            case "test":
                return "Verifica";
            case "interrogation":
                return "Orale";
            case "homework":
                return "Per casa";
            case "other":
                return "Altro";
            default:
                return "Scegli";
        }
    };

    const isSubjectInDate = (subject, day=date) => {
        const dayTimetable = timetable?.[day?.getDay()];
        if (!dayTimetable)
            return false;

        return Object.values(dayTimetable).filter(({ subjectTitle }) => subjectTitle === subject).length > 0;
    };

    const generateCalendar = () => {
        if (window.Worker) {
            const worker = new Worker(`${process.env.PUBLIC_URL}/workers/functions.js`);
            worker.onmessage = response => {
                setCalendar(response.data);
                worker.terminate();
            };
            worker.postMessage({ query: constants.WORKER_QUERIES.GENERATE_CALENDAR });

            return;
        }

        const now = new Date();
        let date = new Date(now.getFullYear() - 1, 0, 1);
        let weeks = [];
        let week = -1;

        while (date.getDay() !== 1)
            date = addDays(date, 1);

        while (date.getFullYear() <= now.getFullYear() + 1) {
            if (date.getDay() === 1)
                week += 1;

            if (!weeks[week])
                weeks.push([]);

            weeks[week].push(date);
            date = addDays(date, 1);
        }

        setCalendar(weeks);
        return weeks;
    };

    const compareDates = (firstDate, secondDate, strict=false) => {
        if (!firstDate || !secondDate) 
            return false;

        if (strict)
            return firstDate.getTime() === secondDate.getTime();
        
        return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
    };

    const dateInPeriod = (start, date, end) => {
        if (!start || !date || !end)
            return false;
            
        return (compareDates(start, date) || start.getTime() < date.getTime()) && date.getTime() < end.getTime();
    };
    
    const dateBefore = (firstDate, secondDate, strict=false) => {
        if (strict)
            return firstDate.getTime() < secondDate.getTime();

        return (
            (firstDate.getFullYear() < secondDate.getFullYear()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() < secondDate.getMonth()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() < secondDate.getDate()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() === secondDate.getDate() && firstDate.getHours() < secondDate.getUTCHours()) ||
            (firstDate.getFullYear() === secondDate.getFullYear() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getDate() === secondDate.getDate() && firstDate.getHours() === secondDate.getUTCHours() && firstDate.getMinutes() < secondDate.getUTCMinutes())
        );
    };

    const getDateEvents = (day=date) => {
        const getEvents = events => {
            if (!events)
                return [];

            const toReturn = [];
            Object.values(events).forEach(event => {
                if (event.type === "interrogation" && dateInPeriod(new Date(event.startDate), day, new Date(event.endDate)) && isSubjectInDate(event.subject, day))
                    toReturn.push(event);
                else if (compareDates(day, new Date(event.date)))
                    toReturn.push(event);
            });

            return toReturn;
        };

        return [...getEvents(tests), ...getEvents(interrogations), ...getEvents(homeworks), ...getEvents(others)];
    };
    
    const allEventsDone = (events) => {
        if (!user)
            return;

        for (const event of Object.values(events)) {
            if (event.type === "interrogation" && !event.done?.[user.id])
                return false;

            if (event.type !== "interrogation" && !event.done?.[user.id])
                return false;
        }

        return true;
    };

    const setChecked = async (event, done) => {
        if (!user)
            return false;

        const setState = event.type === "test" ? setTests : event.type === "interrogation" ? setInterrogations : event.type === "homework" ? setHomeworks : setOthers;
        setState(oldState => ({
            ...oldState,
            [event.id]: {
                ...event,
                done: {
                    ...event.done,
                    [user.id]: done
                }
            }
        }));

        await updateDoc(doc(db, `schools/${user?.school}/classes/${user?.class}/${event.type}s/`, event.id), { [`done.${user.id}`]: done });
    };
    
    const hasNegativeGrades = day => {
        for (const event of getDateEvents(day)) {
            if (event.grades?.[user?.id]?.grade < 5.5) {                
                if (event.type !== "interrogation")   
                    return true;
                
                if (compareDates(day, new Date(event.startDate)))
                    return true;
            }
        }
    };

    const hasMiddleGrades = day => {
        for (const event of getDateEvents(day)) {
            if (event.grades?.[user?.id]?.grade >= 5.5 && event.grades?.[user?.id]?.grade < 6) {
                if (event.type !== "interrogation")   
                    return true;
                
                if (compareDates(day, new Date(event.startDate)))
                    return true;
            }
        }
    };

    const hasPositiveGrades = day => {
        for (const event of getDateEvents(day)) {
            if (event.grades?.[user?.id]?.grade > 6) {                
                if (event.type !== "interrogation")   
                    return true;
                
                if (compareDates(day, new Date(event.startDate)))
                    return true;
            }
        }
    };

    useEffect(() => {
        generateCalendar();
    }, []);

    useEffect(() => {
        if (calendar) {
            const today = new Date();
            calendar.forEach(week => week.forEach(day => {
                if (day.getDate() === today.getDate() && day.getMonth() === today.getMonth() && day.getFullYear() === today.getFullYear()) {
                    setCalendarActiveSlide(calendar.indexOf(week));
                    swiper.current?.swiper?.slideTo(calendar.indexOf(week));
                }
            }));
        }
    }, [calendar, swiperLoaded, props.option]);

    return <main className={ style.main }>
        <Banner id="calendar" />
        { calendar && <section className={ style.calendar }>
            <h3 className={ style.month }>{ getItalianMonth(calendar[calendarActiveSlide][0].getMonth()) } { calendar[calendarActiveSlide][0].getFullYear() }</h3>
            <div className={ style.week } style={{ background: "rgb(80, 80, 80)", marginBottom: "0", borderRadius: ".5rem" }}>
                <p className={ style.day }>L</p>
                <p className={ style.day }>M</p>
                <p className={ style.day }>M</p>
                <p className={ style.day }>G</p>
                <p className={ style.day }>V</p>
                <p className={ style.day }>S</p>
                <p className={ style.day }>D</p>
            </div>
            <Swiper direction='vertical' slidesPerView={ 4 } style={{ height: "26vh" }} ref={ swiper } onSwiper={ () => setSwiperLoaded(true) } onSlideChange={ ({ activeIndex }) => setCalendarActiveSlide(activeIndex) }>
                { calendar.map((week, index) => <SwiperSlide key={ index } style={{ height: "5vh", marginTop: "1.5vh" }}>
                    <div className={ style.week }>
                        { week.map(day => <div key={ `calendar-${day.getDate()}-${day.getMonth()}` } className={ style.day }>
                            <p className={ [style.day, compareDates(day, date) && style.selected, compareDates(day, new Date()) && style.today].join(" ") } onClick={ () => setDate(day) }>{ day.getDate() }</p>
                            { getDateEvents(day).length > 0 && <span className={ style.eventsIndicator } style={{ background: (dateBefore(day, new Date()) || allEventsDone(getDateEvents(day))) && hasNegativeGrades(day) ? "rgb(255, 0, 0)" : hasMiddleGrades(day) ?  "rgb(255, 166, 0)" : hasPositiveGrades(day) ? "rgb(0, 128, 0)" : "rgb(100, 100, 100)" }}>{ getDateEvents(day).length }</span> }
                        </div>) }
                    </div>
                </SwiperSlide>) }
            </Swiper>
        </section> }
        <section className={ style.events }>
            { getDateEvents().map((event, key) => <div key={ `event-${key}` } className={ style.event }>
                <div className={ style.flex }>
                    <img src={ getTypeIcon(event.type, event.done?.[user?.id]) } className={ style.eventTypeIcon } onClick={ () => setPage({ page: "add", event }) }></img>
                    <img src={ icons[getSubjectIcon(event.subject)] } className={  style.eventSubjectIcon } onClick={ () => setPage({ page: "add", event }) }></img>
                    <div style={{ flex: "1" }} onClick={ () => setPage({ page: "add", event }) }>
                        <h4 className={ style.eventSubject } style={{ textDecoration: event.done?.[user?.id] ? "line-through" : "none" }}>{ event.subject }</h4>
                        <h5 className={ style.eventType } style={{ textDecoration: event.done?.[user?.id] ? "line-through" : "none" }}>{ getItalianType(event.type) }</h5>
                    </div>
                    <h4 className={ style.grade } style={{ background: event.grades?.[user.id]?.grade && (!event.grades?.[user.id]?.inGradeAverage ? "rgb(0, 99, 248)" : parseFloat(event.grades?.[user.id]?.grade) >= 6 ? "rgb(0, 128, 0)" : parseFloat(event.grades?.[user.id]?.grade) >= 5.5 ? "rgb(255, 166, 0)" : "rgb(255, 0, 0)") }}>{ getLiteralGrade(event.grades?.[user?.id]?.grade) }</h4>
                    <Checkbox id={ `event-${event.id}` } style={{ marginTop: ".75rem", marginRight: ".25rem", zIndex: "100" }} checked={ event.done?.[user?.id] } onChange={ e => setChecked(event, e.target.checked) } />
                </div>
                <h5 className={ style.eventDescription } style={{ textDecoration: event.done?.[user?.id] ? "line-through" : "none" }} onClick={ () => setPage({ page: "add", event }) }>{ event.title }</h5>
                <div className={ style.attachments }>
                    { event.attachments?.map(attachment => <div className={ style.attachment } key={ `attachment-${attachment}` }>
                        <img src={ getAttachmentIcon(attachment.split(".")[1]) } className={ style.attachmentTypeIcon }></img>
                        <h5 className={ style.attachmentName }>{ attachment.split(".").slice(0, attachment.split(".").length - 1) }</h5>
                        <img src={ icons.download_icon } className={ style.downloadIcon } onClick={ async e => {
                            e.stopPropagation();

                            const url = await getDownloadURL(ref(storage, `${user.school}/${user.class}/${event.type}s/${event.id}/${attachment}`));
                            const a = document.createElement('a');

                            a.href = url;
                            a.click();
                            a.remove();
                        } }></img>
                    </div>) }
                </div>
            </div>) }
            { getDateEvents().length === 0 && <>
                <Lottie
                    style={{ backgroundColor: "rgb(44, 44, 44)", width: "200px", height: "200px", marginLeft: "auto", marginRight: "auto" }}
                    loop={ false }
                    autoplay={ true }
                    speed={ 0.1 }
                    animationData={ check_animation }
                />
                <h4 style={{ textAlign: "center", fontSize: "1.1rem" }}>Nessun evento!</h4>
            </> }
        </section>
    </main>
};

export default Calendar;